const data = {
  five: {
    amount: 5,
    price: 10,
  },
  twentyFive: {
    amount: 25,
    price: 40,
  },
  fifty: {
    amount: 50,
    price: 70,
  },
};
export { data };
